import { Button, Space, Typography } from 'antd';
import React, { useState, useEffect } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { ManageFooter, StyledDrawer, SignalTitle } from './styled';
import { FlexFill } from '../../../common/Utils/Layout';
import apptracker from '@src/utils/sensor/apptracker';
import { selectedFrustrationSignalsAtom, updateFrustrationSignalOrderAtom } from '../../atoms';
import { useAtom } from 'jotai';
import DrawerCard from './DrawerCard';
import useFrustrationSignalOverview from '../../hooks/useFrustrationSignalOverview';

const { Text } = Typography;

const OVERVIEW_FRUSTRATION_SIGNAL_MAX_COUNT = 10;

const trackSignals = (signals: string[]) => {
  apptracker('Add Frustration Signals', {
    signals,
  });
};

function FrustrationSignalControl() {
  const { frustrationSignals } = useFrustrationSignalOverview();

  const [selected, setSelected] = useAtom(selectedFrustrationSignalsAtom);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (open) {
      setSelected(frustrationSignals);
    }
  }, [open, setSelected]);

  const handleClick = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
    setSelected([]); // reset state
  };

  const onClear = () => {
    setSelected([]);
  };

  // Get the update atom
  const [, updateOrder] = useAtom(updateFrustrationSignalOrderAtom);

  const applySignals = () => {
    // Update frustration signal order - persistence is handled automatically at the dashboard level
    updateOrder(selected);
    trackSignals(selected);

    // Close the drawer
    onClose();
  };

  const renderDrawerTitle = () => {
    const count = selected.length;
    return (
      <SignalTitle>
        <div>
          Frustration Signals{' '}
          <Text
            type={count > OVERVIEW_FRUSTRATION_SIGNAL_MAX_COUNT ? 'warning' : undefined}
            className="signal-drawer-title"
          >
            {' '}
            {count}/{OVERVIEW_FRUSTRATION_SIGNAL_MAX_COUNT} Added{' '}
          </Text>
        </div>
      </SignalTitle>
    );
  };

  const footer = (
    <ManageFooter>
      <Button onClick={onClear} disabled={selected.length === 0}>
        Clear All
      </Button>
      <FlexFill />
      <Button onClick={onClose}>Cancel</Button>
      <Button
        onClick={applySignals}
        type="primary"
        disabled={selected.length === 0 || selected.length > OVERVIEW_FRUSTRATION_SIGNAL_MAX_COUNT}
      >
        Apply
      </Button>
    </ManageFooter>
  );

  return (
    <>
      <Space>
        <Button onClick={handleClick} icon={<PlusOutlined />}>
          Frustration Signal
        </Button>
      </Space>
      <StyledDrawer
        title={renderDrawerTitle()}
        placement="right"
        onClose={onClose}
        open={open}
        footer={footer}
        destroyOnHidden={true}
      >
        <DrawerCard isDrawerOpen={open} />
      </StyledDrawer>
    </>
  );
}

export default FrustrationSignalControl;
